import clsx from 'clsx';
import React, { useCallback } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import HighlightedText from '../../highlighted-text/HighlightedText';
import CompanyLogo from '../../company-logo/CompanyLogo';

function TdDomain({ domain, company, logo, inFocus, myCompany, searchTerm, onChooseDomain, isLeft }) {
  const value = company || domain;

  const handleChooseDomain = useCallback(() => {
    if (onChooseDomain) {
      onChooseDomain(domain);
    }
  }, [onChooseDomain, domain]);

  return (
    <StyledTooltip
      title={<TooltipContent company={company} domain={domain} />}
      placement='top'
      disableInteractive
      arrow>
      <div
        className={clsx(
          'td',
          'cell-title',
          inFocus && 'inFocus',
          myCompany && 'myCompany',
          onChooseDomain && 'clickable',
          isLeft && 'td--left',
        )}
        onClick={handleChooseDomain}
        role='presentation'>
        <CompanyLogo logo={logo} size={26} />
        <div className='wrapped-text wrapped-text--2'>
          <HighlightedText value={value} searchTerm={searchTerm} />
        </div>
      </div>
    </StyledTooltip>
  );
}

const TooltipContent = ({ company, domain }) => {
  return (
    <>
      <span>{company}</span>
      <span>{domain}</span>
    </>
  );
};

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '-8px',
  },
});

export default TdDomain;
